const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '暑期档必看：2024最燃动作大片合集',
    desc: '从《飞驰人生2》的极速狂飙到《热辣滚烫》的励志蜕变，为你精选今夏最值得看的高分佳作，超清画质免广告畅享。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20collage%20with%20warm%20golden%20and%20crimson%20tones%2C%20film%20poster%20style%20montage%2C%20summer%20blockbuster%20theme%2C%20dramatic%20lighting%2C%20vibrant%20composition%2C%20movie%20theater%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产剧逆袭之路：繁花引领品质浪潮',
    desc: '从《繁花》的年代质感，到多部高分国剧的口碑突围，国产电视剧正迎来最好的时代。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Chinese%20drama%20cinematic%20scene%20collage%20with%20warm%20amber%20and%20deep%20red%20tones%2C%201990s%20Shanghai%20aesthetic%2C%20film%20poster%20style%2C%20elegant%20composition%2C%20nostalgic%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '高清修复经典：那些年我们追过的港片',
    desc: '周星驰喜剧、成龙动作、王家卫文艺……经典港片高清修复版陆续上线，重温黄金年代的银幕记忆。',
    tag: '经典重温',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20collage%20with%20warm%20vintage%20tones%2C%20golden%20age%20film%20poster%20style%2C%20nostalgic%20movie%20aesthetic%2C%20crimson%20and%20amber%20color%20palette%2C%20cinematic%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '韩流再起：2024高分韩剧追剧指南',
    desc: '悬疑、爱情、治愈……覆盖全类型的精选韩剧榜单，从经典必看到最新热播，一站式追剧体验。',
    tag: '追剧指南',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20collage%20with%20warm%20moody%20tones%2C%20modern%20romance%20and%20thriller%20film%20poster%20style%2C%20amber%20and%20coral%20color%20palette%2C%20elegant%20composition%2C%20cinematic%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              焦点推荐
            </h2>
            <p className="text-sm text-foreground-600">编辑团队精心挑选的观影专题</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            {CAROUSEL_ITEMS.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[8/5] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}